import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Layout from '@/layout';
export default {
  path: '/followUpHandle',
  component: Layout,
  redirect: '/followUpHandle',
  name: 'followUpHandle',
  meta: {
    title: '随访任务处置',
    icon: 'jichu'
  },
  hidden: false,
  children: [{
    path: 'errorPatient',
    component: function component() {
      return import('@/views/followUpHandle/errorPatient/index.vue');
    },
    name: 'errorPatient',
    meta: {
      title: '异常患者管理'
    },
    hidden: false
  }, {
    path: 'foodAdjust',
    component: function component() {
      return import('@/views/followUpHandle/foodAdjust/index.vue');
    },
    name: 'foodAdjust',
    meta: {
      title: '膳食调整'
    },
    hidden: false
  }, {
    path: 'medicationAdjust',
    component: function component() {
      return import('@/views/followUpHandle/medicationAdjust/index.vue');
    },
    name: 'medicationAdjust',
    meta: {
      title: '用药调整'
    },
    hidden: false
  }, {
    path: 'returnVisitReservation',
    component: function component() {
      return import('@/views/followUpHandle/returnVisitReservation/index.vue');
    },
    name: 'returnVisitReservation',
    meta: {
      title: '复诊预约'
    },
    hidden: false
  }, {
    path: 'motionAdjust',
    component: function component() {
      return import('@/views/followUpHandle/motionAdjust/index.vue');
    },
    name: 'motionAdjust',
    meta: {
      title: '运动调整'
    },
    hidden: false
  }]
};